/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("CanvasTextController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class CanvasTextController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class CanvasTextController extends cls.ControllerBase /** @lends classes.CanvasTextController.prototype */ {
    static __name = "CanvasTextController";

    _initBehaviors() {
      super._initBehaviors();

      this._addBehavior(cls.CanvasTextParametersVMBehavior);
      this._addBehavior(cls.CanvasFillColorVMBehavior);
      this._addBehavior(cls.CanvasItemOnClickUIBehavior);
    }

    onAfterLayout() {
      this.applyBehaviors(null, true);
    }
  }

  cls.CanvasTextController = CanvasTextController;
  cls.ControllerFactory.register("CanvasText", cls.CanvasTextController);
});
